import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=2d9c70ca&scoped=true&"
import script from "./product-card.vue?vue&type=script&lang=js&"
export * from "./product-card.vue?vue&type=script&lang=js&"
import style0 from "./product-card.vue?vue&type=style&index=0&id=2d9c70ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c70ca",
  null
  
)

export default component.exports